import React from 'react'

export default function EndOfList({ loading, handleClick, loadedCount, noMorePagesToLoad }) {
    if (loadedCount === 0 && !loading) return (
        <div className='row justify-content-center mt-lg-4 mt-md-4'>
            <div className="col col-12 col-lg-10">
                <h4>
                    Enter a keyword above to find job postings that match your criteria
                </h4>
            </div>
        </div>
    )

    if (noMorePagesToLoad && !loading) {
        return (
            <div className='row justify-content-center mt-lg-4 mt-md-4'>
                <div className="col col-12 col-lg-10">
                    <h6 className="text-faded">That's All Folks!</h6>
                </div>
            </div>
        )
    }

    return (
        <button
            onClick={handleClick}
            disabled={loading}
            className="btn btn-lg btn-block btn-link"
        >
            Load More
        </button>
    )
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/components/EndOfList.js